<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-list>
            @for (item of example.items; track item) {
                <uilab-mat-list-item>{{ item }}</uilab-mat-list-item>
            }
        </uilab-mat-list>
    </avd-code-example>
}
